<template>
  <div class="">

    <Head />


    <div class="main reservation">
      <AccesskeyLink target="accesskey_c" accesskey="c" :aria-label="$t('跳到中央內容區塊')">
        {{ $t(':::') }}
      </AccesskeyLink>

      <!-- 毛毛蟲 -->
      <nav aria-label="breadcrumb" class="breadcrumb_box">
        <div class="container">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><router-link to="/" :title="$t('首頁')">{{ $t('首頁') }}</router-link></li>
            <li class="breadcrumb-item"><router-link to="/Reservation" :title="$t('參觀預約')">{{ $t('參觀預約') }}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('團體預約') }}</li>
          </ol>
        </div>
      </nav>


      <div class="reservation_box">

        <div class="container">

          <div class="title_box">
            <h2 v-if="regType === '有限制人數'">{{ $t('團體預約') }}</h2>
            <h2 v-else>{{ $t('導覽預約') }}</h2>
          </div>

          <div class="reservation_date">

            <p>{{ $t('您所預約的日期為：') }}<span>{{ reservationDate }}</span></p>

          </div>


          <div class="form_box">

            <!-- 報名類型（隱藏，從路由參數取得） -->

            <div class="group reservationTime_box">
              <label for="" class="form-label">{{ $t('預約時間') }}<span class="required">{{ $t('（必填）') }}</span></label>

              <div class="check_box">
                <div class="form-check" v-for="item in reservationTimeITems" :key="item.value">
                  <input class="form-check-input" type="radio" name="reservationTime"
                    :id="`reservationTime_${item.value}`" :value="item.value" :disabled="item.isFull"
                    v-model="selectedTime">
                  <label class="form-check-label" :class="{ 'full': item.isFull }"
                    :for="`reservationTime_${item.value}`">
                    {{ item.title }}
                  </label>
                </div>
              </div>
              <p v-if="errors.selectedTime" class="text-danger">{{ errors.selectedTime }}</p>
            </div>

            <div class="group">
              <label for="applicantUnit" class="form-label">{{ $t('申請單位') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <input type="text" class="form-control" id="applicantUnit" :placeholder="$t('請輸入申請單位')"
                v-model="formData.applicantUnit">
              <p v-if="errors.applicantUnit" class="text-danger">{{ errors.applicantUnit }}</p>
            </div>

            <div class="group">
              <label for="" class="form-label">{{ $t('單位類型') }}<span class="required">{{ $t('（必填）') }}</span></label>

              <div class="check_box">
                <div class="form-check" v-for="item in unitTypeItems" :key="item.value">
                  <input class="form-check-input" type="radio" name="unitType" :id="`unitType_${item.value}`"
                    :value="item.value" v-model="unitType">
                  <label class="form-check-label" :for="`unitType_${item.value}`">
                    {{ item.title }}
                  </label>
                </div>
              </div>

              <div class="other" v-if="unitType === '其他'">
                <input type="text" class="form-control" id="unitTypeOther" :placeholder="$t('請輸入其他類型')"
                  v-model="unitTypeOther">
              </div>
              <p v-if="errors.unitType" class="text-danger">{{ errors.unitType }}</p>
              <p v-if="errors.unitTypeOther" class="text-danger">{{ errors.unitTypeOther }}</p>
            </div>

            <div class="group">
              <label for="" class="form-label">{{ $t('貴團年齡層分布(以最大宗為主)') }}<span class="required">{{ $t('（必填）') }}</span></label>

              <div class="check_box">
                <div class="form-check" v-for="item in ageGroupItems" :key="item.value">

                  <input class="form-check-input" type="radio" name="ageGroup" :id="`ageGroup_${item.value}`"
                    :value="item.value" v-model="ageGroup">
                  <label class="form-check-label" :for="`ageGroup_${item.value}`">
                    {{ item.title }}
                  </label>
                </div>
              </div>
              <p v-if="errors.ageGroup" class="text-danger">{{ errors.ageGroup }}</p>

            </div>

            <div class="group">
              <label for="groupName" class="form-label">{{ $t('團體代表姓名') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <input type="text" class="form-control" id="groupName" :placeholder="$t('請輸入參觀日聯絡人或導遊／領隊姓名')"
                v-model="formData.groupName">
              <p v-if="errors.groupName" class="text-danger">{{ errors.groupName }}</p>
            </div>

            <div class="group">
              <label for="groupMobile" class="form-label">{{ $t('團體代表手機') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <input type="text" class="form-control" id="groupMobile" :placeholder="$t('請輸入參觀日聯絡人或導遊／領隊電話')"
                v-model="formData.groupMobile">
              <p v-if="errors.groupMobile" class="text-danger">{{ errors.groupMobile }}</p>
            </div>


            <div class="group" v-if="regType === '有限制人數'">
              <label for="" class="form-label">{{ $t('參觀人數') }}<span class="required">{{ $t('（必填）') }}</span></label>

              <select v-model="count" class="form-select" aria-label="">
                <option v-for="n in (max - min + 1)" :key="n" :value="n + min - 1">
                  {{ n + min - 1 }}
                </option>
              </select>
              <p class="notes">{{ $t('(長者及6歲以下學童皆須計算人數在內)') }}</p>
              <!-- <p v-if="regType === '有限制人數'" class="notes">有限制人數時，參觀人數須介於 20-30 人</p>
              <p v-if="regType === '無限制人數'" class="notes">無限制人數時，參觀人數須大於等於 1 人</p> -->
              <p v-if="errors.count" class="text-danger">{{ errors.count }}</p>
            </div>

            <div class="group">
              <label for="name" class="form-label">{{ $t('申請人姓名') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <input type="text" class="form-control" id="name" :placeholder="$t('請輸入姓名')" v-model="formData.name">
              <p v-if="errors.name" class="text-danger">{{ errors.name }}</p>
            </div>

            <div class="group">
              <label for="idCard" class="form-label">{{ $t('申請人身分證字號') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <input type="text" class="form-control" id="idCard" :placeholder="$t('請輸入身分證字號')"
                v-model="formData.idCard">
              <p v-if="errors.idCard" class="text-danger">{{ errors.idCard }}</p>
            </div>

            <div class="group">
              <label for="mobile" class="form-label">{{ $t('申請人手機') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <input type="text" class="form-control" id="mobile" :placeholder="$t('請輸入手機')" v-model="formData.mobile">
              <p v-if="errors.mobile" class="text-danger">{{ errors.mobile }}</p>
            </div>

            <div class="group">
              <label for="email" class="form-label">{{ $t('申請人電子信箱') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <input type="email" class="form-control" id="email" :placeholder="$t('請輸入電子信箱')" v-model="formData.email">
              <p v-if="errors.email" class="text-danger">{{ errors.email }}</p>
            </div>

            <div class="group">
              <label for="remarks" class="form-label">{{ $t('預約備註') }}</label>
              <textarea class="form-control" id="remarks" rows="3" :placeholder="$t('請輸入預約備註')"
                v-model="formData.remarks"></textarea>
            </div>


            <div class="group requirement_box">

              <div class="notes">
                <p>{{ $t('※ 若無法順利媒合導覽老師，將以電子信件或電話通知，故請確認聯繫資料填寫正確') }}</p>
                <p>{{ $t('※ 參觀當天請出示名冊並預先確認符合半票或免費入場資格者人數') }}</p>
              </div>

              <div class="check_box">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" id="requirement_3" v-model="agree">
                  <label class="form-check-label" for="requirement_3">
                    {{ $t('我已經詳細閱讀並同意') }} <router-link class="rule_link" :to="{ name: 'Post', params: { PId: 64 } }" :title="$t('使用規範（另開新視窗）')"
                      target="_blank">{{ $t('使用規範') }}</router-link>
                  </label>
                </div>
              </div>
              <p v-if="errors.agree" class="text-danger">{{ errors.agree }}</p>

            </div>

            <div class="btn_box">
              <button class="send_btn" @click="gotoPage('/Reservation')">{{ $t('重選日期') }}</button>
              <button class="send_btn" @click="submitForm" :disabled="isSubmitting">
                {{ isSubmitting ? $t('送出中...') : $t('確認送出') }}
              </button>
            </div>

          </div>

        </div>

      </div>



    </div>

    <Footer />

  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Footer from '@/components/Footer.vue';

import AccesskeyLink from '@/views/AccesskeyLink.vue'


export default {
  name: 'ReservationForm',
  components: {
    Head,
    Footer,

    AccesskeyLink,

  },

  data() {
    return {

      reservationDate: "",
      selectedDate: "",

      // 選擇時間
      selectedTime: null,
      reservationTimeITems: [],

      // 報名類型
      regType: "",

      // 單位類型
      unitType: "",
      unitTypeOther: "",

      // 年齡層分布
      ageGroup: "",

      // 表單資料
      formData: {
        applicantUnit: '',
        groupName: '',
        groupMobile: '',
        count: 20,
        name: '',
        idCard: '',
        mobile: '',
        email: '',
        remarks: '',
      },

      // 人數
      count: 20, // 預設值
      min: 20,
      max: 30,

      // 注意事項確認
      requirement1: false,
      requirement2: false,
      agree: false,

      // 表單驗證錯誤
      errors: {},

      // 送出中狀態
      isSubmitting: false,

    };
  },

  computed: {
    // 單位類型項目
    unitTypeItems() {
      return [
        {
          value: '學校機關',
          title: this.$t('學校機關'),
        },
        {
          value: '旅行業者',
          title: this.$t('旅行業者'),
        },
        {
          value: '媒體記者',
          title: this.$t('媒體記者'),
        },
        {
          value: '私人企業',
          title: this.$t('私人企業'),
        },
        {
          value: '公務機關',
          title: this.$t('公務機關'),
        },
        {
          value: '其他',
          title: this.$t('其他'),
        },
      ]
    },

    // 年齡層項目
    ageGroupItems() {
      return [
        {
          value: '幼稚園',
          title: this.$t('幼稚園'),
        },
        {
          value: '國小',
          title: this.$t('國小'),
        },
        {
          value: '國中',
          title: this.$t('國中'),
        },
        {
          value: '高中',
          title: this.$t('高中'),
        },
        {
          value: '大學(含研究所)',
          title: this.$t('大學(含研究所)'),
        },
        {
          value: '社會人士',
          title: this.$t('社會人士'),
        },
        {
          value: '樂齡長者(65歲以上)',
          title: this.$t('樂齡長者(65歲以上)'),
        },
      ]
    },

    // 根據報名類型調整人數範圍
    visitorCountRange() {
      if (this.regType === '有限制人數') {
        return { min: 20, max: 30 }
      } else if (this.regType === '無限制人數') {
        return { min: 1, max: 100 }
      }
      return { min: 1, max: 30 }
    },
  },

  watch: {
    regType(newVal) {
      // 當報名類型改變時，調整人數範圍
      const range = this.visitorCountRange
      this.min = range.min
      this.max = range.max
      
      // 如果是無限制人數，設定為 1
      if (newVal === '無限制人數') {
        this.count = 1
      } else {
        // 如果當前人數超出範圍，調整為最小值
        if (this.count < this.min) {
          this.count = this.min
        } else if (this.count > this.max) {
          this.count = this.max
        }
      }
    },
  },

  async mounted() {
    // 從 sessionStorage 獲取日期和報名類型
    const date = sessionStorage.getItem('reservationDate')
    const regType = sessionStorage.getItem('regType')
    
    if (!date) {
      alert(this.$t('請先選擇日期'))
      this.$router.push('/Reservation')
      return
    }

    if (!regType) {
      alert(this.$t('請先選擇報名類型'))
      this.$router.push('/Reservation')
      return
    }

    this.selectedDate = date
    this.reservationDate = this.formatDisplayDate(date)
    this.regType = regType

    // 如果是無限制人數，設定人數為 1
    if (regType === '無限制人數') {
      this.count = 1
    }

    // 載入該日期的可用時段
    await this.loadAvailableSlots()
  },

  methods: {

    // 格式化顯示日期
    formatDisplayDate(dateStr) {
      try {
        const parts = dateStr.split('-')
        return `${parts[0]}${this.$t('年')}${parts[1]}${this.$t('月')}${parts[2]}${this.$t('日')}`
      } catch {
        return dateStr
      }
    },

    // 載入可用時段
    async loadAvailableSlots() {
      try {
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaGroupReg/Public/GetAvailableSlots?date=${this.selectedDate}`
        
        const response = await fetch(apiUrl, {
          method: 'GET',
        })
        
        const data = await response.json()
        
        if (data.ok) {
          this.reservationTimeITems = data.timeSlots.map(slot => ({
            value: slot.timeSlot,
            title: slot.timeSlot,
            isFull: slot.isFull,
          }))
        }
      } catch (error) {
        console.error('載入時段失敗:', error)
        alert(this.$t('載入時段資訊失敗，請稍後再試'))
      }
    },

    // 表單驗證
    validateForm() {
      this.errors = {}

      if (!this.selectedTime) {
        this.errors.selectedTime = this.$t('請選擇預約時間')
      }

      if (!this.formData.applicantUnit) {
        this.errors.applicantUnit = this.$t('請輸入申請單位')
      }

      if (!this.unitType) {
        this.errors.unitType = this.$t('請選擇單位類型')
      }

      if (this.unitType === '其他' && !this.unitTypeOther) {
        this.errors.unitTypeOther = this.$t('請輸入其他類型')
      }

      if (!this.ageGroup) {
        this.errors.ageGroup = this.$t('請選擇年齡層')
      }

      if (!this.formData.groupName) {
        this.errors.groupName = this.$t('請輸入團體代表姓名')
      }

      if (!this.formData.groupMobile) {
        this.errors.groupMobile = this.$t('請輸入團體代表手機')
      } else if (!/^09\d{8}$/.test(this.formData.groupMobile)) {
        this.errors.groupMobile = this.$t('請輸入有效的手機號碼（格式：09XXXXXXXX）')
      }

      // 人數驗證
      const range = this.visitorCountRange
      if (this.count < range.min || this.count > range.max) {
        this.errors.count = `${this.$t('參觀人數須介於')} ${range.min}-${range.max} ${this.$t('人')}`
      }

      if (!this.formData.name) {
        this.errors.name = this.$t('請輸入申請人姓名')
      }

      if (!this.formData.idCard) {
        this.errors.idCard = this.$t('請輸入申請人身分證字號')
      } else if (!this.validateTaiwanId(this.formData.idCard)) {
        this.errors.idCard = this.$t('請輸入有效的台灣身分證字號')
      }

      if (!this.formData.mobile) {
        this.errors.mobile = this.$t('請輸入申請人手機')
      } else if (!/^09\d{8}$/.test(this.formData.mobile)) {
        this.errors.mobile = this.$t('請輸入有效的手機號碼（格式：09XXXXXXXX）')
      }

      if (!this.formData.email) {
        this.errors.email = this.$t('請輸入申請人電子信箱')
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formData.email)) {
        this.errors.email = this.$t('請輸入有效的電子信箱')
      }

      if (!this.agree) {
        this.errors.agree = this.$t('請閱讀並同意使用規範後再送出')
      }

      return Object.keys(this.errors).length === 0
    },

    // 台灣身分證字號驗證
    validateTaiwanId(value) {
      if (!value) return false
      
      const pattern = /^[A-Z][12]\d{8}$/
      if (!pattern.test(value)) return false
      
      // 字母轉數字對照表
      const letterMap = {
        A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, G: 16, H: 17, I: 34, J: 18,
        K: 19, L: 20, M: 21, N: 22, O: 35, P: 23, Q: 24, R: 25, S: 26, T: 27,
        U: 28, V: 29, W: 32, X: 30, Y: 31, Z: 33
      }
      
      const firstLetter = value.charAt(0)
      const num = letterMap[firstLetter]
      
      // 計算檢查碼
      let sum = Math.floor(num / 10) + (num % 10) * 9
      for (let i = 1; i < 9; i++) {
        sum += parseInt(value.charAt(i)) * (9 - i)
      }
      sum += parseInt(value.charAt(9))
      
      return sum % 10 === 0
    },

    // 送出表單
    async submitForm() {
      if (!this.validateForm()) {
        const firstError = Object.keys(this.errors)[0]
        const errorElement = document.getElementById(firstError)
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
        return
      }

      if (this.isSubmitting) return
      this.isSubmitting = true

      try {
        const requestData = {
          RegDate: this.selectedDate,
          TimeSlot: this.selectedTime,
          RegType: this.regType,
          OrganizationName: this.formData.applicantUnit,
          OrganizationType: this.unitType,
          OrganizationTypeOther: this.unitType === '其他' ? this.unitTypeOther : null,
          AgeGroup: this.ageGroup,
          RepresentativeName: this.formData.groupName,
          RepresentativePhone: this.formData.groupMobile,
          VisitorCount: this.count,
          ApplicantName: this.formData.name,
          ApplicantIdCard: this.formData.idCard,
          ApplicantPhone: this.formData.mobile,
          ApplicantEmail: this.formData.email,
          Remarks: this.formData.remarks || null,
        }

        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaGroupReg/Public/Create`
        
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData),
        })

        const data = await response.json()

        if (data.ok) {
          alert(data.message || this.$t('報名成功！待管理員審核後將以電子郵件通知您'))
          this.$router.push('/Reservation')
        } else {
          alert(data.message || this.$t('報名失敗，請稍後再試'))
        }
      } catch (error) {
        console.error('提交失敗:', error)
        alert(this.$t('提交時發生錯誤，請稍後再試'))
      } finally {
        this.isSubmitting = false
      }
    },

    gotoPage(path) {
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },


  },

}

</script>
